module.exports = __webpack_public_path__ + "img/9788989571704.c0b27fc2.jpg";